import { useCallback } from 'react';
import { useBlocker } from 'react-router-dom';

type UseReactRouterBlockerParams = {
  shouldBlock: boolean;
  message: string;
};

/**
 * Hook to block React Router navigation with a confirmation dialog
 * Uses React Router v6's useBlocker API
 */
export const useReactRouterBlocker = ({ shouldBlock, message }: UseReactRouterBlockerParams) => {
  useBlocker(
    useCallback(() => {
      if (shouldBlock) {
        return !window.confirm(message);
      }
      return false;
    }, [shouldBlock, message])
  );
};

export default useReactRouterBlocker;
